import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=4d050dba&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d050dba')) {
      api.createRecord('4d050dba', component.options)
    } else {
      api.reload('4d050dba', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=4d050dba&", function () {
      api.rerender('4d050dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UHtvHmy1h2xy/JS/costHelpSixtyTage.vue"
export default component.exports